import {
    LOCK_UI,
    UNLOCK_UI,
    UPDATE_CALENDAR,
    UPDATE_COUNTERPARTS,
    UPDATE_CONFIGURATION,
    UPDATE_FILTERS,
    UPDATE_PERMISSIONS,
    // BLOCK_CALENDAR,
    // UNBLOCK_CALENDAR,
} from '../actionsTypes'

const initialState = {
    calendar: [],
    counterpartList: [],
    configuration: 0,
    isUIEnabled: true,
    // Permisos del usuario (vienen de /authenticate y /personalPackage).
    // Defaults seguros: BR habilitado, modo legacy, sin grupos, sin LR.
    businessRoundEnabled: true,
    businessRoundMatchmakingMode: 'RegistrationType',
    registrationGroups: [],
    leadRetrievalEnabled: false,
    filters: {
        categories: [],
        investmentRanges: [],
    },
    spotlightCompany: false,
}

const businessRoundsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_CALENDAR:
            return {
                ...state,
                calendar: payload
            }
        case UPDATE_COUNTERPARTS:
            return {
                ...state,
                counterpartList: payload
            }
        case LOCK_UI:
            return {
                ...state,
                isUIEnabled: false,
            }
        case UNLOCK_UI:
            return {
                ...state,
                isUIEnabled: true,
            }
        case UPDATE_CONFIGURATION:
            return {
                ...state,
                configuration: payload
            }
        case UPDATE_FILTERS:
            return {
                ...state,
                filters: payload,
            }
        case UPDATE_PERMISSIONS: {
            // Partial merge: solo sobreescribe los campos presentes en payload.
            // Permite tanto hidrataciones completas (login/personalPackage)
            // como flips puntuales (toggle de opt-in del usuario).
            const next = { ...state };
            if (payload.businessRoundEnabled !== undefined) next.businessRoundEnabled = payload.businessRoundEnabled;
            if (payload.businessRoundMatchmakingMode !== undefined) next.businessRoundMatchmakingMode = payload.businessRoundMatchmakingMode;
            if (payload.registrationGroups !== undefined) next.registrationGroups = payload.registrationGroups;
            if (payload.leadRetrievalEnabled !== undefined) next.leadRetrievalEnabled = payload.leadRetrievalEnabled;
            return next;
        }
        // case BLOCK_CALENDAR:
        //     return {
        //         ...state,
        //         isEnabled: false
        //     }
        // case UNBLOCK_CALENDAR:
        //     return {
        //         ...state,
        //         isEnabled: true
        //     }
        default:
            return state;
    }
}

export default businessRoundsReducer
